
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRoutePlanning as ObiRoutePlanningElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-planning.js';
 
 
 

 
 export const ObiRoutePlanning = createComponent({
   react: React,
   tagName: 'obi-route-planning',
   elementClass: ObiRoutePlanningElement,
   events: {
     
   }
  });
 
 